var isMobile = function () {
    return window.innerWidth < 960;
};
export var DeviceUtils = {
    isMobile: isMobile,
};
